module.exports = __webpack_public_path__ + "static/img/portal-gauge1.fb6374d4.png";